import {React, useState} from "react";
import { Button, useMediaQuery} from "@mui/material";
import { BiLoaderCircle } from "react-icons/bi";
import { set } from "react-hook-form";

// import T from "prop-types";

const MarketingRow = ({
  id,
  startDate,
  endDate,  
  Discount,
  name,
  TcsFuncded,
  updateCampaign
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const convertDate = (date) =>{
    
    const dateTime = new Date(date);

    const formattedDateTime = dateTime.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    return formattedDateTime;
  }
  const endCampiagn= async ()=>{
    setIsLoading(true);
    await updateCampaign({id:id});
    setIsLoading(false);
  }
  const isSmallScreen = useMediaQuery('(max-width:600px)');
   
  return (
    <>      
      
   
    <div >
      <div  className="space-bottom2 space-top" style={{whiteSpace: isSmallScreen ? 'normal' : 'nowrap', paddingLeft: '5px', textAlign: isSmallScreen ?'center' : ''}}>
        <label className="bold">Campaign Name: </label>
        <span id="category-value">{name}</span>
      </div>
    <div style={{ whiteSpace: isSmallScreen ? 'normal' : 'nowrap', display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div  className="space-bottom2" style={{paddingLeft: '5px'}}>
        <label className="bold">Discount: </label>
        <span id="discount-value">{Discount}</span>
      </div>      
      <div  className="space-bottom2" style={{paddingLeft: '5px'}}>
        <label className="bold">Start Date: </label>
        <span id="start-date-value">{convertDate(startDate)}</span>
      </div>
      <div  className="space-bottom2" style={{paddingLeft: '5px'}}>
        <label className="bold">End Date: </label>
        <span id="end-date-value">{convertDate(endDate)}</span>
        
      </div>
    </div>
    <div style={{ whiteSpace: isSmallScreen ? 'normal' : 'nowrap', display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem'}}>
      <div className="space-bottom2">
        
        <span id="isTcsFunded" style={{ textAlign: 'center', fontSize: '12px', color: 'green', paddingLeft:'30px', backgroundColor: 'white' }}>{TcsFuncded ? 'TCS-Funded' : ''}</span>
      </div>
      <div className="space-bottom2" style={{marginTop: '10px' }}>
      <Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />}
                                                onClick={() => endCampiagn()}
                                                variant="contained" color="primary">
                                                End Campaign
                                        </Button>
        </div>
    </div>
    </div>
   
  
    </>
  );
};

export default MarketingRow;


